import apiFetch from './client';

export type MembershipRole = 'MANAGER' | 'USER';
export type MembershipStatus = 'ACTIVE' | 'INVITED' | 'SUSPENDED';

export interface Membership {
  id: string;
  condominiumId: string;
  userId: string;
  role: MembershipRole;
  status: MembershipStatus;
  createdAt: string;
  updatedAt: string;
}

export interface CreateMembershipPayload {
  apartmentId: string;
  userId: string;
  role: MembershipRole;
  status?: MembershipStatus;
}

export interface UpdateMembershipPayload {
  role?: MembershipRole;
  status?: MembershipStatus;
}

export async function createMembership(payload: CreateMembershipPayload): Promise<Membership> {
  return apiFetch<Membership>('/memberships', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function updateMembership(
  membershipId: string,
  payload: UpdateMembershipPayload,
): Promise<Membership> {
  return apiFetch<Membership>(`/memberships/${membershipId}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
}

export async function deleteMembership(membershipId: string): Promise<void> {
  await apiFetch<void>(`/memberships/${membershipId}`, { method: 'DELETE' });
}
